/*
 * KJR 2014-07-07
 * js google maps class
 * requires: jquery & google maps
 * includes: OverlappingMarkerSpiderfier, MarkerClusterer
*/
function gMap(mapId, xmlDataURL, options) {
	//publicly accessible properties
	this.map;
	this.settings = {};

	//private variables
	var gMap = this;
	var center;
	var mapIsLoaded = false;
	var bounds = new google.maps.LatLngBounds();
	var markers = [];
	var infoWindow = new google.maps.InfoWindow();

	var defaults = {
		center: [39.50, -98.35], //center of US
		forceCenter: false,
		zoomLevel: null,
		panControl: false,
		adjustZoom: -1,
		markerType: 'pin',
		markerColor: 'red',
		markerSize: 'small',
		markerSpidering: true,
		markerSpideringOptions: {
			markersWontMove: true,
			markersWontHide: true,
			keepSpiderfied: true,
			nearbyDistance: 5 //pixels
		},
		scrollUsability: true,
		searchBox: false,
		clusterMarkers: false,
		markerClustererOptions: {
			minimumClusterSize: 4,
			maxZoom: 7,
			gridSize: 53,
			averageCenter: true,
			styles: [{
				url: 'images/maps/cluster-blue.png',
				width: 53,
				height: 52,
				textColor: '#036',
				textSize: '9'
			}]
		},
		bgHue: null,
		bgSaturation: 1,
		bgLightness: 1,
		bgGamma: 1
	};

	// Merge defaults and options, without modifying defaults
	this.settings = $.extend( {}, defaults, options );

	//function loadMap() {
	this.loadMap = function () {
		center = new google.maps.LatLng(gMap.settings['center'][0], gMap.settings['center'][1]);
		gMap.map = new google.maps.Map(document.getElementById(mapId), {
			center: center,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			panControl: gMap.settings['panControl'],
			styles: [{
				stylers: [
					{ "hue": gMap.settings['bgHue'] },
					{ "gamma": gMap.settings['bgGamma'] },
					{ "lightness": gMap.settings['bgLightness'] },
					{ "saturation": gMap.settings['bgSaturation'] }
				]
			}]
		});
		if (gMap.settings['markerSpidering']) {
			var oms = new OverlappingMarkerSpiderfier(gMap.map, gMap.settings['markerSpideringOptions']);
		}

		$.ajax({
			type: "get",
			url: xmlDataURL,
			cache: false,
			dataType: 'xml',
			success: function(xml){
				$(xml).find('marker').each(function(){
					var marker = gMap.buildMarker(this);
					markers.push(marker);
					//if (markerType == 'hq') marker.setZIndex(999);
					google.maps.event.addListener(marker, 'click', function() {
						infoWindow.setContent(marker.desc);
						infoWindow.open(gMap.map, marker);
					});

					//marker spidering
					if (gMap.settings['markerSpidering']) {
						oms.addMarker(marker);
					}

					// extend bounds
					bounds.extend(marker.getPosition());
				});

				//cluster markers
				if (gMap.settings['clusterMarkers']) {
					initMarkerClusterer();
				}

				gMap.map.fitBounds(bounds); //changes center and zoom level to fit all points

				// toggle draggable option on resize
				google.maps.event.addDomListener(window, 'resize', function() {
					clearTimeout(this.id);
					this.id = setTimeout(recenterMap, 500);
				});
				//run mapLoaded function once map is completely loaded
				google.maps.event.addListener(gMap.map, 'idle', function(){
					if(!mapIsLoaded){
						recenterMap();
						mapIsLoaded = true;
					}
				});
			},
			error: function(jqXHR, ajaxOptions, errorThrown) {
				console.log('Error getting map data.');
				//console.log("Error type: "+ajaxOptions);
				console.log("Error: "+errorThrown);
				console.log("statusText: " + jqXHR.statusText);
				console.log("responseText: " + jqXHR.responseText);
				console.log("status: " + jqXHR.status);
			},
			complete: function() {
				try {
				} catch (e) {
					alert(e);
				}
			}
		});

		// Create the search box and link it to the UI element.
		if (gMap.settings['searchBox']) {
			initSearchBox();
		}

		if (gMap.settings['legend']) {
			makeLegend(gMap.settings['legendOptions']['title'], gMap.settings['legendOptions']['styles']);
		}

		// enable zoom on scroll after map interactivity
		if (gMap.settings['scrollUsability']) {
			initScrollUsability(mapId);
		}

		return gMap;
	};

	this.getMarkerName = function(data) {
		var companyName = data.getAttribute("name");
		return companyName;
	};

	this.buildMarker = function(data) {
		var companyId = data.getAttribute("company_id");
		var markerName = gMap.getMarkerName(data);
		var nic = data.getAttribute("nic");
		if (nic !== null && nic !== '') markerName = nic;
		var hq = data.getAttribute("hq");
		var address = data.getAttribute("address");
		var address2 = data.getAttribute("address2");
		var location = data.getAttribute("location");
		var zip = data.getAttribute("zip");
		var phone_to = data.getAttribute("phone_to");
		var phone = data.getAttribute("phone");
		var fax = data.getAttribute("fax");
		var website = data.getAttribute("website");
		var markerColor = data.getAttribute("markerColor");
		if (markerColor == null || markerColor == '') markerColor = gMap.settings['markerColor'];
		var markerSize = data.getAttribute("markerSize");
		if (markerSize == null || markerSize == '') markerSize = gMap.settings['markerSize'];
		var lat = data.getAttribute("lat");
		var lng = data.getAttribute("lng");
		var point = new google.maps.LatLng(
			parseFloat(lat),
			parseFloat(lng)
		);
		var drivingDirectionsToURL = 'http://maps.google.com/maps?saddr=&daddr='+escape(address+'+'+location+'+'+zip);
		var drivingDirectionsFromURL = 'http://maps.google.com/maps?daddr=&saddr='+escape(address+'+'+location+'+'+zip);
		var html = '<div class="googleMapsBubble"><b>'+markerName + '</b>';
		if (address.length > 0) {
			html = html + '<br />' + address + ((address2.length > 0) ? '<br />' + address2 : '');
		}
		html += '<br />' + location + ' ' + zip +
			((phone_to.length > 0) ? '<br /><b>Toll-Free:</b> ' + phone_to : '') +
			((phone.length > 0) ? '<br /><b>Tel:</b> ' + phone : '') +
			((fax.length > 0) ? '<br /><b>Fax:</b> ' + fax : '') + '<br />' +
			'Directions: <a href="'+drivingDirectionsToURL+'" target="_blank">To here</a> - <a href="'+drivingDirectionsFromURL+'" target="_blank">From here</a>';
		html += '</div>';
		//if (hq == 'yes') {
		//	var myIcon = gMap.mapIcons['hq'];
		//} else {
			var myIcon = gMap.mapIcons[gMap.settings['markerType']][markerColor][markerSize];
		//}
		var marker = new google.maps.Marker({
			map: gMap.map,
			position: point,
			icon: myIcon,
			desc: html
		});

		return marker;
	};

	function recenterMap() {
		if (gMap.settings['forceCenter']) {
			gMap.map.setCenter(center);
			//setTimeout(function(){gMap.map.setCenter(center);}, 500);
		} else {
			//changes center and zoom level to fit all points
			gMap.map.fitBounds(bounds);
		}
		//set zoom
		var zoomLevel = getZoomDefault();
		gMap.map.setZoom(zoomLevel);
	}

	function getZoomDefault() {
		var zoomLevel;
		if (gMap.settings['zoomLevel']) {
			zoomLevel = gMap.settings['zoomLevel'];
			// now adjust for screen width
			var viewportWidth = $(window).width();
			if (viewportWidth < 800) {
				//zoom out
				zoomLevel = zoomLevel - 1;
			}
			if (viewportWidth < 400) {
				//zoom out further
				zoomLevel = zoomLevel - 1;
			}
			if (zoomLevel < 0) zoomLevel = 0;
		} else {
			// no zoom level set
			if (markers.length == 1) {
				// if there is only one marker, zoom to 10
				zoomLevel = 10;
			} else {
				// set zoom to bounds
				zoomLevel = gMap.map.getZoom()+eval(gMap.settings['adjustZoom']);
			}
		}

		return zoomLevel;
	}

	function initScrollUsability() {
		google.maps.event.addListener(gMap.map, 'mousedown', function(){
			enableScrollingWithMouseWheel();
		});

		$('body').on('mousedown', function(event) {
			var clickedInsideMap = $(event.target).parents('#'+mapId).length > 0;

			if(!clickedInsideMap) {
				disableScrollingWithMouseWheel();
			}
		});

		$(window).scroll(function() {
			disableScrollingWithMouseWheel();
		});
	}

	function enableScrollingWithMouseWheel() {
	    gMap.map.setOptions({ scrollwheel: true });
	}

	function disableScrollingWithMouseWheel() {
	    gMap.map.setOptions({ scrollwheel: false });
	}

	function initSearchBox() {
		$("#"+mapId).append('<input id="'+mapId+'-search" class="gmap-search" type="text" placeholder="Search">');
		var input = (document.getElementById(mapId+'-search'));
		gMap.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

		var searchBox = new google.maps.places.SearchBox((input));

		// Listen for the event fired when the user selects an item from the
		// pick list. Retrieve the matching places for that item.
		google.maps.event.addListener(searchBox, 'places_changed', function() {
			var places = searchBox.getPlaces();

			// For each place, get the icon, place name, and location.
			//var markers = [];
		    var bounds = new google.maps.LatLngBounds();
		    for (var i = 0, place; place = places[i]; i++) {
		      var image = {
		        url: place.icon,
		        size: new google.maps.Size(71, 71),
		        origin: new google.maps.Point(0, 0),
		        anchor: new google.maps.Point(17, 34),
		        scaledSize: new google.maps.Size(25, 25)
		      };

		      // Create a marker for each place.
		      //markers.push(marker);

		      bounds.extend(place.geometry.location);
		    }

		    gMap.map.fitBounds(bounds);
			//gMap.map.setCenter(center);
			gMap.map.setZoom(8);
		});

		// Bias the SearchBox results towards places that are within the bounds of the
		// current map's viewport.
		google.maps.event.addListener(gMap.map, 'bounds_changed', function() {
			var bounds = gMap.map.getBounds();
			searchBox.setBounds(bounds);
		});
	}

	this.goToLocation = function(location) {
	    var geocoder = new google.maps.Geocoder();

	    geocoder.geocode( { 'address': location }, function(results, status) {
	        if (status == google.maps.GeocoderStatus.OK) {
	            gMap.map.setZoom(8);
	            gMap.map.panTo(results[0].geometry.location);
	        }
	        else {
	            alert('Geocode was not successful for the following reason: ' + status);
	        }
	    });
	};

	function makeLegend(title, styles) {
		$("#"+mapId).append('<div id="'+mapId+'-legend" class="gmap-legend"><b>'+title+'</b></div>');
		var legendDiv = (document.getElementById(mapId+'-legend'));
		gMap.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legendDiv);
		var legend = document.getElementById(mapId+'-legend');
		var container = document.createElement('dl');
		for (i = 0; i < styles.length; i++) {
			var name = styles[i]['name'];
			var icon = styles[i]['icon'];
			container.innerHTML += '<dt><img src="'+icon+'" alt="'+name+'" /></dt><dd>'+name+'</dd>';
		}
		legend.appendChild(container);
	}

	function initMarkerClusterer() {
		var markerClusterer = new MarkerClusterer(gMap.map, markers, gMap.settings['markerClustererOptions']);
	}

	this.mapIcons = {
		hq: new google.maps.MarkerImage('images/maps/marker-hq.png',
			new google.maps.Size(32.0, 32.0), // (width, height)
			new google.maps.Point(0, 0),
			new google.maps.Point(16.0, 16.0) // (width/2, height)
		),
		marker: {
			red: {
				normal: new google.maps.MarkerImage('images/maps/marker-red-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-red-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			green: {
				normal: new google.maps.MarkerImage('images/maps/marker-green-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-green-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			blue: {
				normal: new google.maps.MarkerImage('images/maps/marker-blue-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-blue-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			yellow: {
				normal: new google.maps.MarkerImage('images/maps/marker-yellow-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-yellow-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			purple: {
				normal: new google.maps.MarkerImage('images/maps/marker-purple-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-purple-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			pink: {
				normal: new google.maps.MarkerImage('images/maps/marker-pink-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-pink-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			orange: {
				normal: new google.maps.MarkerImage('images/maps/marker-orange-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-orange-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			sky: {
				normal: new google.maps.MarkerImage('images/maps/marker-sky-dot.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/marker-sky-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			}
		},
		pin: {
			red: {
				normal: new google.maps.MarkerImage('images/maps/pin-red.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-red-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			bronze: {
				normal: new google.maps.MarkerImage('images/maps/pin-bronze.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-bronze-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			green: {
				normal: new google.maps.MarkerImage('images/maps/pin-green.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-green-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			blue: {
				normal: new google.maps.MarkerImage('images/maps/pin-blue.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-blue-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			yellow: {
				normal: new google.maps.MarkerImage('images/maps/pin-yellow.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-yellow-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			purple: {
				normal: new google.maps.MarkerImage('images/maps/pin-purple.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-purple-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			pink: {
				normal: new google.maps.MarkerImage('images/maps/pin-pink.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-pink-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			orange: {
				normal: new google.maps.MarkerImage('images/maps/pin-orange.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-orange-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
			sky: {
				normal: new google.maps.MarkerImage('images/maps/pin-sky.png',
					new google.maps.Size(32.0, 32.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(16.0, 32.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/pin-sky-small.png',
					new google.maps.Size(24.0, 24.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(12.0, 24.0) // (width/2, height)
				),
			},
		},
		dot: {
			red: {
				normal: new google.maps.MarkerImage('images/maps/dot-red-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-red-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			green: {
				normal: new google.maps.MarkerImage('images/maps/dot-green-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-green-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			blue: {
				normal: new google.maps.MarkerImage('images/maps/dot-blue-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-blue-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			yellow: {
				normal: new google.maps.MarkerImage('images/maps/dot-yellow-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-yellow-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			purple: {
				normal: new google.maps.MarkerImage('images/maps/dot-purple-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-purple-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			pink: {
				normal: new google.maps.MarkerImage('images/maps/dot-pink-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-pink-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			orange: {
				normal: new google.maps.MarkerImage('images/maps/dot-orange-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-orange-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
			sky: {
				normal: new google.maps.MarkerImage('images/maps/dot-sky-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
				small: new google.maps.MarkerImage('images/maps/dot-sky-small.png',
					new google.maps.Size(9.0, 9.0), // (width, height)
					new google.maps.Point(0, 0),
					new google.maps.Point(4.5, 9.0) // (width/2, height)
				),
			},
		},
	};
}


/**
 * OverlappingMarkerSpiderfier
 * https://github.com/jawj/OverlappingMarkerSpiderfier
 * Copyright (c) 2011 - 2012 George MacKerron
 * Released under the MIT licence: http://opensource.org/licenses/mit-license
 * Note: The Google Maps API v3 must be included *before* this code
 */
(function(){
var h=!0,u=null,v=!1;
(function(){var A,B={}.hasOwnProperty,C=[].slice;if(((A=this.google)!=u?A.maps:void 0)!=u)this.OverlappingMarkerSpiderfier=function(){function w(b,d){var a,g,f,e,c=this;this.map=b;d==u&&(d={});for(a in d)B.call(d,a)&&(g=d[a],this[a]=g);this.e=new this.constructor.g(this.map);this.n();this.b={};e=["click","zoom_changed","maptypeid_changed"];g=0;for(f=e.length;g<f;g++)a=e[g],p.addListener(this.map,a,function(){return c.unspiderfy()})}var p,s,t,q,k,c,y,z;c=w.prototype;z=[w,c];q=0;for(k=z.length;q<k;q++)t=
z[q],t.VERSION="0.3.3";s=google.maps;p=s.event;k=s.MapTypeId;y=2*Math.PI;c.keepSpiderfied=v;c.markersWontHide=v;c.markersWontMove=v;c.nearbyDistance=20;c.circleSpiralSwitchover=9;c.circleFootSeparation=23;c.circleStartAngle=y/12;c.spiralFootSeparation=26;c.spiralLengthStart=11;c.spiralLengthFactor=4;c.spiderfiedZIndex=1E3;c.usualLegZIndex=10;c.highlightedLegZIndex=20;c.legWeight=1.5;c.legColors={usual:{},highlighted:{}};q=c.legColors.usual;t=c.legColors.highlighted;q[k.HYBRID]=q[k.SATELLITE]="#fff";
t[k.HYBRID]=t[k.SATELLITE]="#f00";q[k.TERRAIN]=q[k.ROADMAP]="#444";t[k.TERRAIN]=t[k.ROADMAP]="#f00";c.n=function(){this.a=[];this.j=[]};c.addMarker=function(b){var d,a=this;if(b._oms!=u)return this;b._oms=h;d=[p.addListener(b,"click",function(d){return a.F(b,d)})];this.markersWontHide||d.push(p.addListener(b,"visible_changed",function(){return a.o(b,v)}));this.markersWontMove||d.push(p.addListener(b,"position_changed",function(){return a.o(b,h)}));this.j.push(d);this.a.push(b);return this};c.o=function(b,
d){if(b._omsData!=u&&(d||!b.getVisible())&&!(this.s!=u||this.t!=u))return this.unspiderfy(d?b:u)};c.getMarkers=function(){return this.a.slice(0)};c.removeMarker=function(b){var d,a,g,f,e;b._omsData!=u&&this.unspiderfy();d=this.m(this.a,b);if(0>d)return this;g=this.j.splice(d,1)[0];f=0;for(e=g.length;f<e;f++)a=g[f],p.removeListener(a);delete b._oms;this.a.splice(d,1);return this};c.clearMarkers=function(){var b,d,a,g,f,e,c,m;this.unspiderfy();m=this.a;b=g=0;for(e=m.length;g<e;b=++g){a=m[b];d=this.j[b];
f=0;for(c=d.length;f<c;f++)b=d[f],p.removeListener(b);delete a._oms}this.n();return this};c.addListener=function(b,d){var a,g;((g=(a=this.b)[b])!=u?g:a[b]=[]).push(d);return this};c.removeListener=function(b,d){var a;a=this.m(this.b[b],d);0>a||this.b[b].splice(a,1);return this};c.clearListeners=function(b){this.b[b]=[];return this};c.trigger=function(){var b,d,a,g,f,e;d=arguments[0];b=2<=arguments.length?C.call(arguments,1):[];d=(a=this.b[d])!=u?a:[];e=[];g=0;for(f=d.length;g<f;g++)a=d[g],e.push(a.apply(u,
b));return e};c.u=function(b,d){var a,g,f,e,c;f=this.circleFootSeparation*(2+b)/y;g=y/b;c=[];for(a=e=0;0<=b?e<b:e>b;a=0<=b?++e:--e)a=this.circleStartAngle+a*g,c.push(new s.Point(d.x+f*Math.cos(a),d.y+f*Math.sin(a)));return c};c.v=function(b,d){var a,g,f,e,c;f=this.spiralLengthStart;a=0;c=[];for(g=e=0;0<=b?e<b:e>b;g=0<=b?++e:--e)a+=this.spiralFootSeparation/f+5E-4*g,g=new s.Point(d.x+f*Math.cos(a),d.y+f*Math.sin(a)),f+=y*this.spiralLengthFactor/a,c.push(g);return c};c.F=function(b,d){var a,g,f,e,c,
m,l,x,n;e=b._omsData!=u;(!e||!this.keepSpiderfied)&&this.unspiderfy();if(e||this.map.getStreetView().getVisible()||"GoogleEarthAPI"===this.map.getMapTypeId())return this.trigger("click",b,d);e=[];c=[];a=this.nearbyDistance;m=a*a;f=this.c(b.position);n=this.a;l=0;for(x=n.length;l<x;l++)a=n[l],a.map!=u&&a.getVisible()&&(g=this.c(a.position),this.f(g,f)<m?e.push({A:a,p:g}):c.push(a));return 1===e.length?this.trigger("click",b,d):this.G(e,c)};c.markersNearMarker=function(b,d){var a,g,f,e,c,m,l,x,n,p;
d==u&&(d=v);if(this.e.getProjection()==u)throw"Must wait for 'idle' event on map before calling markersNearMarker";a=this.nearbyDistance;c=a*a;f=this.c(b.position);e=[];x=this.a;m=0;for(l=x.length;m<l;m++)if(a=x[m],!(a===b||a.map==u||!a.getVisible()))if(g=this.c((n=(p=a._omsData)!=u?p.l:void 0)!=u?n:a.position),this.f(g,f)<c&&(e.push(a),d))break;return e};c.markersNearAnyOtherMarker=function(){var b,d,a,g,c,e,r,m,l,p,n,k;if(this.e.getProjection()==u)throw"Must wait for 'idle' event on map before calling markersNearAnyOtherMarker";
e=this.nearbyDistance;b=e*e;g=this.a;e=[];n=0;for(a=g.length;n<a;n++)d=g[n],e.push({q:this.c((r=(l=d._omsData)!=u?l.l:void 0)!=u?r:d.position),d:v});n=this.a;d=r=0;for(l=n.length;r<l;d=++r)if(a=n[d],a.map!=u&&a.getVisible()&&(g=e[d],!g.d)){k=this.a;a=m=0;for(p=k.length;m<p;a=++m)if(c=k[a],a!==d&&(c.map!=u&&c.getVisible())&&(c=e[a],(!(a<d)||c.d)&&this.f(g.q,c.q)<b)){g.d=c.d=h;break}}n=this.a;a=[];b=r=0;for(l=n.length;r<l;b=++r)d=n[b],e[b].d&&a.push(d);return a};c.z=function(b){var d=this;return{h:function(){return b._omsData.i.setOptions({strokeColor:d.legColors.highlighted[d.map.mapTypeId],
zIndex:d.highlightedLegZIndex})},k:function(){return b._omsData.i.setOptions({strokeColor:d.legColors.usual[d.map.mapTypeId],zIndex:d.usualLegZIndex})}}};c.G=function(b,d){var a,c,f,e,r,m,l,k,n,q;this.s=h;q=b.length;a=this.C(function(){var a,d,c;c=[];a=0;for(d=b.length;a<d;a++)k=b[a],c.push(k.p);return c}());e=q>=this.circleSpiralSwitchover?this.v(q,a).reverse():this.u(q,a);a=function(){var a,d,k,q=this;k=[];a=0;for(d=e.length;a<d;a++)f=e[a],c=this.D(f),n=this.B(b,function(a){return q.f(a.p,f)}),
l=n.A,m=new s.Polyline({map:this.map,path:[l.position,c],strokeColor:this.legColors.usual[this.map.mapTypeId],strokeWeight:this.legWeight,zIndex:this.usualLegZIndex}),l._omsData={l:l.position,i:m},this.legColors.highlighted[this.map.mapTypeId]!==this.legColors.usual[this.map.mapTypeId]&&(r=this.z(l),l._omsData.w={h:p.addListener(l,"mouseover",r.h),k:p.addListener(l,"mouseout",r.k)}),l.setPosition(c),l.setZIndex(Math.round(this.spiderfiedZIndex+f.y)),k.push(l);return k}.call(this);delete this.s;this.r=
h;return this.trigger("spiderfy",a,d)};c.unspiderfy=function(b){var d,a,c,f,e,k,m;b==u&&(b=u);if(this.r==u)return this;this.t=h;f=[];c=[];m=this.a;e=0;for(k=m.length;e<k;e++)a=m[e],a._omsData!=u?(a._omsData.i.setMap(u),a!==b&&a.setPosition(a._omsData.l),a.setZIndex(u),d=a._omsData.w,d!=u&&(p.removeListener(d.h),p.removeListener(d.k)),delete a._omsData,f.push(a)):c.push(a);delete this.t;delete this.r;this.trigger("unspiderfy",f,c);return this};c.f=function(b,d){var a,c;a=b.x-d.x;c=b.y-d.y;return a*
a+c*c};c.C=function(b){var d,a,c,f,e;f=a=c=0;for(e=b.length;f<e;f++)d=b[f],a+=d.x,c+=d.y;b=b.length;return new s.Point(a/b,c/b)};c.c=function(b){return this.e.getProjection().fromLatLngToDivPixel(b)};c.D=function(b){return this.e.getProjection().fromDivPixelToLatLng(b)};c.B=function(b,c){var a,g,f,e,k,m;f=k=0;for(m=b.length;k<m;f=++k)if(e=b[f],e=c(e),"undefined"===typeof a||a===u||e<g)g=e,a=f;return b.splice(a,1)[0]};c.m=function(b,c){var a,g,f,e;if(b.indexOf!=u)return b.indexOf(c);a=f=0;for(e=b.length;f<
e;a=++f)if(g=b[a],g===c)return a;return-1};w.g=function(b){return this.setMap(b)};w.g.prototype=new s.OverlayView;w.g.prototype.draw=function(){};return w}()}).call(this);}).call(this);
/* Tue 7 May 2013 14:56:02 BST */

/**
 * FOUND HERE: http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclusterer/
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0.1
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 * <br/>
 * This is a v3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >v2 MarkerClusterer</a>.
 */

function d(a){return function(b){this[a]=b}}function f(a){return function(){return this[a]}}var k;
function l(a,b,c){this.extend(l,google.maps.OverlayView);this.b=a;this.a=[];this.f=[];this.da=[53,56,66,78,90];this.j=[];this.A=!1;c=c||{};this.g=c.gridSize||60;this.l=c.minimumClusterSize||2;this.K=c.maxZoom||null;this.j=c.styles||[];this.Y=c.imagePath||this.R;this.X=c.imageExtension||this.Q;this.P=!0;void 0!=c.zoomOnClick&&(this.P=c.zoomOnClick);this.r=!1;void 0!=c.averageCenter&&(this.r=c.averageCenter);m(this);this.setMap(a);this.L=this.b.getZoom();var e=this;google.maps.event.addListener(this.b,
"zoom_changed",function(){var a=e.b.getZoom(),b=e.b.minZoom||0,c=Math.min(e.b.maxZoom||100,e.b.mapTypes[e.b.getMapTypeId()].maxZoom),a=Math.min(Math.max(a,b),c);e.L!=a&&(e.L=a,e.m())});google.maps.event.addListener(this.b,"idle",function(){e.i()});b&&(b.length||Object.keys(b).length)&&this.C(b,!1)}k=l.prototype;k.R="http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclusterer/images/m";k.Q="png";
k.extend=function(a,b){return function(a){for(var b in a.prototype)this.prototype[b]=a.prototype[b];return this}.apply(a,[b])};k.onAdd=function(){this.A||(this.A=!0,p(this))};k.draw=function(){};function m(a){if(!a.j.length)for(var b=0,c;c=a.da[b];b++)a.j.push({url:a.Y+(b+1)+"."+a.X,height:c,width:c})}k.T=function(){for(var a=this.o(),b=new google.maps.LatLngBounds,c=0,e;e=a[c];c++)b.extend(e.getPosition());this.b.fitBounds(b)};k.w=f("j");k.o=f("a");k.W=function(){return this.a.length};k.ca=d("K");
k.J=f("K");k.G=function(a,b){for(var c=0,e=a.length,g=e;0!==g;)g=parseInt(g/10,10),c++;c=Math.min(c,b);return{text:e,index:c}};k.aa=d("G");k.H=f("G");k.C=function(a,b){if(a.length)for(var c=0,e;e=a[c];c++)s(this,e);else if(Object.keys(a).length)for(e in a)s(this,a[e]);b||this.i()};function s(a,b){b.s=!1;b.draggable&&google.maps.event.addListener(b,"dragend",function(){b.s=!1;a.M()});a.a.push(b)}k.q=function(a,b){s(this,a);b||this.i()};
function t(a,b){var c=-1;if(a.a.indexOf)c=a.a.indexOf(b);else for(var e=0,g;g=a.a[e];e++)if(g==b){c=e;break}if(-1==c)return!1;b.setMap(null);a.a.splice(c,1);return!0}k.Z=function(a,b){var c=t(this,a);return!b&&c?(this.m(),this.i(),!0):!1};k.$=function(a,b){for(var c=!1,e=0,g;g=a[e];e++)g=t(this,g),c=c||g;if(!b&&c)return this.m(),this.i(),!0};k.V=function(){return this.f.length};k.getMap=f("b");k.setMap=d("b");k.I=f("g");k.ba=d("g");
k.v=function(a){var b=this.getProjection(),c=new google.maps.LatLng(a.getNorthEast().lat(),a.getNorthEast().lng()),e=new google.maps.LatLng(a.getSouthWest().lat(),a.getSouthWest().lng()),c=b.fromLatLngToDivPixel(c);c.x+=this.g;c.y-=this.g;e=b.fromLatLngToDivPixel(e);e.x-=this.g;e.y+=this.g;c=b.fromDivPixelToLatLng(c);b=b.fromDivPixelToLatLng(e);a.extend(c);a.extend(b);return a};k.S=function(){this.m(!0);this.a=[]};
k.m=function(a){for(var b=0,c;c=this.f[b];b++)c.remove();for(b=0;c=this.a[b];b++)c.s=!1,a&&c.setMap(null);this.f=[]};k.M=function(){var a=this.f.slice();this.f.length=0;this.m();this.i();window.setTimeout(function(){for(var b=0,c;c=a[b];b++)c.remove()},0)};k.i=function(){p(this)};
function p(a){if(a.A)for(var b=new google.maps.LatLngBounds(a.b.getBounds().getSouthWest(),a.b.getBounds().getNorthEast()),b=a.v(b),c=0,e;e=a.a[c];c++)if(!e.s&&b.contains(e.getPosition())){for(var g=a,u=4E4,q=null,x=0,n=void 0;n=g.f[x];x++){var h=n.getCenter();if(h){var r=e.getPosition();if(h&&r)var y=(r.lat()-h.lat())*Math.PI/180,z=(r.lng()-h.lng())*Math.PI/180,h=Math.sin(y/2)*Math.sin(y/2)+Math.cos(h.lat()*Math.PI/180)*Math.cos(r.lat()*Math.PI/180)*Math.sin(z/2)*Math.sin(z/2),h=12742*Math.atan2(Math.sqrt(h),
Math.sqrt(1-h));else h=0;h<u&&(u=h,q=n)}}q&&q.F.contains(e.getPosition())?q.q(e):(n=new v(g),n.q(e),g.f.push(n))}}function v(a){this.k=a;this.b=a.getMap();this.g=a.I();this.l=a.l;this.r=a.r;this.d=null;this.a=[];this.F=null;this.n=new w(this,a.w())}k=v.prototype;
k.q=function(a){var b;a:if(this.a.indexOf)b=-1!=this.a.indexOf(a);else{b=0;for(var c;c=this.a[b];b++)if(c==a){b=!0;break a}b=!1}if(b)return!1;this.d?this.r&&(c=this.a.length+1,b=(this.d.lat()*(c-1)+a.getPosition().lat())/c,c=(this.d.lng()*(c-1)+a.getPosition().lng())/c,this.d=new google.maps.LatLng(b,c),A(this)):(this.d=a.getPosition(),A(this));a.s=!0;this.a.push(a);b=this.a.length;b<this.l&&a.getMap()!=this.b&&a.setMap(this.b);if(b==this.l)for(c=0;c<b;c++)this.a[c].setMap(null);b>=this.l&&a.setMap(null);
a=this.b.getZoom();if((b=this.k.J())&&a>b)for(a=0;b=this.a[a];a++)b.setMap(this.b);else this.a.length<this.l?B(this.n):(b=this.k.H()(this.a,this.k.w().length),this.n.setCenter(this.d),a=this.n,a.B=b,a.c&&(a.c.innerHTML=b.text),b=Math.max(0,a.B.index-1),b=Math.min(a.j.length-1,b),b=a.j[b],a.ea=b.url,a.h=b.height,a.p=b.width,a.N=b.textColor,a.e=b.anchor,a.O=b.textSize,a.D=b.backgroundPosition,this.n.show());return!0};
k.getBounds=function(){for(var a=new google.maps.LatLngBounds(this.d,this.d),b=this.o(),c=0,e;e=b[c];c++)a.extend(e.getPosition());return a};k.remove=function(){this.n.remove();this.a.length=0;delete this.a};k.U=function(){return this.a.length};k.o=f("a");k.getCenter=f("d");function A(a){var b=new google.maps.LatLngBounds(a.d,a.d);a.F=a.k.v(b)}k.getMap=f("b");
function w(a,b){a.k.extend(w,google.maps.OverlayView);this.j=b;this.u=a;this.d=null;this.b=a.getMap();this.B=this.c=null;this.t=!1;this.setMap(this.b)}k=w.prototype;
k.onAdd=function(){this.c=document.createElement("DIV");if(this.t){var a=C(this,this.d);this.c.style.cssText=D(this,a);this.c.innerHTML=this.B.text}this.getPanes().overlayMouseTarget.appendChild(this.c);var b=this;google.maps.event.addDomListener(this.c,"click",function(){var a=b.u.k;google.maps.event.trigger(a,"clusterclick",b.u);a.P&&b.b.fitBounds(b.u.getBounds())})};function C(a,b){var c=a.getProjection().fromLatLngToDivPixel(b);c.x-=parseInt(a.p/2,10);c.y-=parseInt(a.h/2,10);return c}
k.draw=function(){if(this.t){var a=C(this,this.d);this.c.style.top=a.y+"px";this.c.style.left=a.x+"px"}};function B(a){a.c&&(a.c.style.display="none");a.t=!1}k.show=function(){if(this.c){var a=C(this,this.d);this.c.style.cssText=D(this,a);this.c.style.display=""}this.t=!0};k.remove=function(){this.setMap(null)};k.onRemove=function(){this.c&&this.c.parentNode&&(B(this),this.c.parentNode.removeChild(this.c),this.c=null)};k.setCenter=d("d");
function D(a,b){var c=[];c.push("background-image:url("+a.ea+");");c.push("background-position:"+(a.D?a.D:"0 0")+";");"object"===typeof a.e?("number"===typeof a.e[0]&&0<a.e[0]&&a.e[0]<a.h?c.push("height:"+(a.h-a.e[0])+"px; padding-top:"+a.e[0]+"px;"):c.push("height:"+a.h+"px; line-height:"+a.h+"px;"),"number"===typeof a.e[1]&&0<a.e[1]&&a.e[1]<a.p?c.push("width:"+(a.p-a.e[1])+"px; padding-left:"+a.e[1]+"px;"):c.push("width:"+a.p+"px; text-align:center;")):c.push("height:"+a.h+"px; line-height:"+a.h+
"px; width:"+a.p+"px; text-align:center;");c.push("cursor:pointer; top:"+b.y+"px; left:"+b.x+"px; color:"+(a.N?a.N:"black")+"; position:absolute; font-size:"+(a.O?a.O:11)+"px; font-family:Arial,sans-serif; font-weight:bold");return c.join("")}window.MarkerClusterer=l;l.prototype.addMarker=l.prototype.q;l.prototype.addMarkers=l.prototype.C;l.prototype.clearMarkers=l.prototype.S;l.prototype.fitMapToMarkers=l.prototype.T;l.prototype.getCalculator=l.prototype.H;l.prototype.getGridSize=l.prototype.I;
l.prototype.getExtendedBounds=l.prototype.v;l.prototype.getMap=l.prototype.getMap;l.prototype.getMarkers=l.prototype.o;l.prototype.getMaxZoom=l.prototype.J;l.prototype.getStyles=l.prototype.w;l.prototype.getTotalClusters=l.prototype.V;l.prototype.getTotalMarkers=l.prototype.W;l.prototype.redraw=l.prototype.i;l.prototype.removeMarker=l.prototype.Z;l.prototype.removeMarkers=l.prototype.$;l.prototype.resetViewport=l.prototype.m;l.prototype.repaint=l.prototype.M;l.prototype.setCalculator=l.prototype.aa;
l.prototype.setGridSize=l.prototype.ba;l.prototype.setMaxZoom=l.prototype.ca;l.prototype.onAdd=l.prototype.onAdd;l.prototype.draw=l.prototype.draw;v.prototype.getCenter=v.prototype.getCenter;v.prototype.getSize=v.prototype.U;v.prototype.getMarkers=v.prototype.o;w.prototype.onAdd=w.prototype.onAdd;w.prototype.draw=w.prototype.draw;w.prototype.onRemove=w.prototype.onRemove;Object.keys=Object.keys||function(a){var b=[],c;for(c in a)a.hasOwnProperty(c)&&b.push(c);return b};
